/* Real prices and eligibility are always calculated by Shopify discounts. */
(() => {
  if (window.TPBundleCart) return;
  const attribute = '_tp_progressive_bundle';
  const root = () => window.Shopify?.routes?.root || '/';
  let config = null, queue = Promise.resolve(), nativeChanges = new Set(), lastQuantityChange = 0;
  const parse = value => { try { return typeof value === 'string' ? JSON.parse(value) : value; } catch { return null; } };
  const autoGift = parse(document.querySelector('[data-tp-auto-gift-config]')?.dataset.tpAutoGiftConfig) || {};
  const giftMarker = '_tp_auto_gift';
  const ownedGift = item => Boolean(item.properties?.[giftMarker]);
  const matchesGift = item => String(item.variant_id || item.id) === String(autoGift.variantId);
  const giftAvailable = () => autoGift.available === true && autoGift.price != null && Number(autoGift.price) === 0 &&
    autoGift.requiresShipping === false && Number(autoGift.variantId) > 0 && String(autoGift.productId) !== String(autoGift.qualifierId);
  let giftCartRelevant = Boolean((autoGift.enabled && autoGift.hasQualifier) || autoGift.hasOwnedGift);
  const valid = value => value && Number(value.productId) > 0 && typeof value.pairCode === 'string' && typeof value.giftCode === 'string';
  const extraCodes = value => Array.isArray(value?.extraCodes) ? value.extraCodes : [];
  const codesOfConfig = value => value ? [value.pairCode, value.giftCode, value.combinedCode, value.orderCode, value.shippingCode, ...extraCodes(value)].filter(code => typeof code === 'string' && code) : [];
  const paidQuantity = quantity => quantity - Math.floor(quantity / 4);
  const equal = (a, b) => a.length === b.length && a.every(x => b.some(y => y.toUpperCase() === x.toUpperCase()));
  const sectionIds = () => [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(x => x.dataset.sectionId))].slice(0, 5);
  const sectionRequest = () => {
    const sections = sectionIds();
    return sections.length ? { sections, sections_url: location.pathname } : {};
  };
  const lock = action => {
    const promise = queue.then(action);
    queue = promise.catch(() => {});
    return promise;
  };
  async function request(path, body) {
    const options = { credentials: 'same-origin', headers: { Accept: 'application/json' } };
    if (body) {
      options.method = 'POST';
      if (body instanceof FormData) options.body = body;
      else { options.headers['Content-Type'] = 'application/json'; options.body = JSON.stringify(body); }
    }
    const response = await fetch(`${root()}cart${path}.js`, options);
    const data = await response.json();
    if (!response.ok || Number(data.status) >= 400 || data.errors) {
      throw new Error(typeof data.description === 'string' ? data.description : (typeof data.errors === 'string' ? data.errors : data.message || 'No se pudo actualizar el carrito. Intenta de nuevo.'));
    }
    return data;
  }
  function orderDiscounts(cart) {
    // Shopify returns allocation wrappers on cart/update.js and flat applications on cart.js.
    return (cart.cart_level_discount_applications || []).flatMap(entry => {
      const app = entry.discount_application ?? entry;
      const code = app.code || app.title;
      return app.type === 'discount_code' && code ? [{ code, amount: entry.amount ?? app.total_allocated_amount }] : [];
    });
  }
  function codes(cart) {
    if (Array.isArray(cart.discount_codes)) return cart.discount_codes.map(x => x.code).filter(Boolean);
    const result = [];
    for (const item of cart.items || []) for (const allocation of item.line_level_discount_allocations || []) {
      const app = allocation.discount_application;
      if (app?.type === 'discount_code') result.push(app.code || app.title);
    }
    for (const discount of orderDiscounts(cart)) result.push(discount.code);
    document.querySelectorAll('[data-discount-code]').forEach(x => result.push(x.dataset.discountCode));
    return [...new Set(result.filter(Boolean))];
  }
  function plan(cart, current) {
    const items = (cart.items || []).filter(item => String(item.product_id) === String(current.productId) && !item.selling_plan_allocation);
    const quantity = items.reduce((sum, item) => sum + Number(item.quantity), 0);
    const includesGift = quantity >= 4;
    const nativeOrder = includesGift && Boolean(current.orderCode);
    const combined = includesGift && !nativeOrder && Boolean(current.combinedCode);
    const productCode = includesGift ? (combined ? current.combinedCode : current.giftCode) : quantity >= 2 && Number(current.pairPercent) > 0 ? current.pairCode : '';
    const orderPercent = Number(current.combinedPercent ?? current.pairPercent);
    const orderCode = nativeOrder && orderPercent > 0 ? current.orderCode : '';
    const flatPrice = Boolean(orderCode) && extraCodes(current).length === 3;
    const extraCode = flatPrice ? extraCodes(current)[quantity % 4 - 1] : '';
    const shippingCode = current.freeShipping && quantity >= Number(current.shippingMinimum || 2) ? current.shippingCode : '';
    const stored = parse(cart.attributes?.[attribute]);
    const owned = new Set([...codesOfConfig(stored), ...codesOfConfig(current)].map(x => x.toUpperCase()));
    const desired = codes(cart).filter(code => !owned.has(code.toUpperCase()));
    if (productCode) desired.push(productCode);
    if (productCode && orderCode) desired.push(orderCode);
    if (productCode && extraCode) desired.push(extraCode);
    if (shippingCode) desired.push(shippingCode);
    return { items, quantity, productCode, combined, nativeOrder, orderCode, orderPercent, flatPrice, extraCode, desired: [...new Set(desired)] };
  }
  function nativeOrderError(cart, selected) {
    const giftCode = selected.productCode.toUpperCase();
    const freeUnits = selected.items.reduce((count, item) => {
      const appliedGift = (item.line_level_discount_allocations || []).some(({ discount_application: app }) =>
        (app?.code || app?.title || '').toUpperCase() === giftCode);
      if (!appliedGift || Number(item.final_line_price ?? item.line_price) !== 0) return count;
      return count + Number(item.quantity);
    }, 0);
    if (!giftCode || freeUnits < Math.floor(selected.quantity / 4)) {
      return 'No se pudo aplicar el collar gratis. Revisa la promoción antes de pagar.';
    }
    if (!selected.orderCode) return '';
    const orderCode = selected.orderCode.toUpperCase();
    const discounts = orderDiscounts(cart);
    const discount = discounts.find(app => app.code.toUpperCase() === orderCode);
    const subtotal = (cart.items || []).reduce((sum, item) =>
      item.gift_card ? sum : sum + Number(item.final_line_price ?? item.line_price), 0);
    const expected = Math.round(subtotal * selected.orderPercent / 100);
    const allocated = Number(discount?.amount);
    if (!Number.isFinite(allocated) || !Number.isFinite(expected) || Math.abs(allocated - expected) > cart.items.length) {
      return 'No se pudo aplicar el descuento al pedido junto con el collar gratis. Revisa la promoción antes de pagar.';
    }
    if (selected.flatPrice) {
      const original = selected.items.reduce((sum, item) => sum + Number(item.original_line_price), 0);
      const paid = selected.items.reduce((sum, item) => sum + Number(item.final_line_price ?? item.line_price), 0);
      const expectedExtra = Math.round((paid - original * 0.75) * (100 - selected.orderPercent) / 100);
      const extra = selected.extraCode ? Number(discounts.find(app => app.code.toUpperCase() === selected.extraCode.toUpperCase())?.amount) : 0;
      if (!Number.isFinite(expectedExtra) || !Number.isFinite(extra) || Math.abs(extra - expectedExtra) > cart.items.length) {
        return 'No se pudo aplicar el precio promocional a los collares adicionales. Intenta de nuevo antes de pagar.';
      }
    }
    return '';
  }
  function discountError(cart, current) {
    const selected = plan(cart, current);
    if (selected.nativeOrder) return nativeOrderError(cart, selected);
    if (!selected.productCode) return '';
    const entry = cart.discount_codes?.find(x => x.code.toUpperCase() === selected.productCode.toUpperCase());
    const original = selected.items.reduce((sum, item) => sum + Number(item.original_line_price ?? item.price * item.quantity), 0);
    const final = selected.items.reduce((sum, item) => sum + Number(item.final_line_price ?? item.line_price), 0);
    let giftValue = 0;
    if (selected.quantity >= 4) {
      // Shopify gives the least expensive eligible unit(s) for free.
      let gifts = Math.floor(selected.quantity / 4);
      for (const item of [...selected.items].sort((a, b) => Number(a.original_price ?? a.price) - Number(b.original_price ?? b.price))) {
        const units = Math.min(gifts, Number(item.quantity));
        giftValue += units * Number(item.original_price ?? item.price);
        gifts -= units;
        if (!gifts) break;
      }
    }
    let percent = selected.quantity < 4 ? Number(current.pairPercent) : 0;
    if (selected.combined) percent = Number(current.combinedPercent ?? current.pairPercent);
    const required = giftValue + Math.round((original - giftValue) * percent / 100);
    if (original - final + selected.quantity < required) return entry?.applicable === false
      ? 'No se pudo aplicar la promoción. Intenta de nuevo antes de pagar.'
      : 'No se pudo validar el precio de la promoción. Intenta de nuevo antes de pagar.';
    return '';
  }
  function publish(cart, quiet = false) {
    document.dispatchEvent(new CustomEvent(quiet ? 'discount:update' : 'cart:update', { bubbles: true, detail: {
      resource: cart, sourceId: 'tp-progressive-bundle',
      data: { source: 'tp-progressive-bundle', itemCount: cart.item_count, sections: cart.sections || {} }
    } }));
  }
  async function reconcileGift(cart, allowAdd) {
    const items = cart.items || [];
    const owned = items.filter(ownedGift);
    const qualifies = autoGift.enabled && Number(autoGift.qualifierId) > 0 && items.some(item =>
      !ownedGift(item) && String(item.product_id) === String(autoGift.qualifierId) && !item.selling_plan_allocation && item.quantity > 0);
    giftCartRelevant = Boolean(qualifies || owned.length);
    if (!qualifies && !owned.length) return { cart, changed: false };
    const available = giftAvailable();
    const isFree = item => Number(item.original_line_price ?? (item.original_price ?? item.price) * item.quantity) === 0 &&
      Number(item.final_line_price ?? item.line_price) === 0 && item.requires_shipping !== true;
    const manual = qualifies && items.some(item => !ownedGift(item) && matchesGift(item));
    const keep = qualifies && available && !manual ? owned.find(item => matchesGift(item) && isFree(item)) : null;
    const updates = {};
    for (const item of owned) {
      if (item !== keep) updates[item.key] = 0;
      else if (item.quantity !== 1) updates[item.key] = 1;
    }
    let changed = Object.keys(updates).length > 0;
    if (changed) cart = await request('/update', { updates });
    if (!qualifies || !allowAdd) {
      giftCartRelevant = Boolean(qualifies || (cart.items || []).some(ownedGift));
      return { cart, changed };
    }
    const error = 'El regalo digital no está disponible sin costo en este momento.';
    if (!available) throw new Error(error);
    if (!manual && !keep) {
      await request('/add', { items: [{ id: Number(autoGift.variantId), quantity: 1, properties: { [giftMarker]: String(autoGift.qualifierId) } }] });
      cart = await request('');
      changed = true;
    }
    if (!(cart.items || []).some(item => matchesGift(item) && isFree(item))) {
      const remove = Object.fromEntries((cart.items || []).filter(ownedGift).map(item => [item.key, 0]));
      if (Object.keys(remove).length) await request('/update', { updates: remove });
      throw new Error(error);
    }
    return { cart, changed };
  }
  async function reconcile(cart, force = false, allowGiftAdd = true) {
    cart ||= await request('');
    const stored = parse(cart.attributes?.[attribute]);
    const current = valid(config) ? config : valid(stored) ? stored : null;
    const giftResult = await reconcileGift(cart, allowGiftAdd);
    cart = giftResult.cart;
    if (current) config = current;
    const selected = current ? plan(cart, current) : null;
    const serialized = current ? JSON.stringify(current) : '';
    if (giftResult.changed || (current && (force || !equal(codes(cart), selected.desired) || cart.attributes?.[attribute] !== serialized))) {
      const sections = sectionIds();
      if (!current && !sections.length) return cart;
      cart = await request('/update', {
        ...(current ? { discount: selected.desired.join(','), attributes: { [attribute]: serialized } } : {}),
        ...(sections.length ? { sections, sections_url: location.pathname } : {})
      });
    }
    return cart;
  }
  function showError(message) {
    for (const holder of document.querySelectorAll('.cart__ctas, .cart__summary, cart-drawer-component dialog, #cart-form')) {
      let node = holder.querySelector('[data-tp-cart-message]');
      if (!node) {
        node = document.createElement('p'); node.dataset.tpCartMessage = ''; node.setAttribute('role', 'alert');
        node.style.cssText = 'color:#c00028;font-size:14px;line-height:1.4;margin:12px 0;'; holder.append(node);
      }
      node.textContent = message;
    }
  }
  const signature = item => JSON.stringify([String(item.variant_id || item.id), Object.entries(item.properties || {}).sort(), item.selling_plan_allocation?.selling_plan?.id || '']);
  function addPayload(form, quantity, includeGift) {
    const body = new FormData();
    for (const [name, value] of form.entries()) {
      // Render the drawer once, after Shopify has applied all discounts.
      if (name === 'sections' || name === 'sections_url') continue;
      if (includeGift && /^(id|quantity|selling_plan|properties)(\[|$)/.test(name)) {
        body.append(`items[0]${name.replace(/^([^\[]+)/, '[$1]')}`, value);
      } else body.append(name, value);
    }
    body.set(includeGift ? 'items[0][quantity]' : 'quantity', String(quantity));
    if (includeGift) {
      body.set('items[1][id]', String(autoGift.variantId));
      body.set('items[1][quantity]', '1');
      body.set(`items[1][properties][${giftMarker}]`, String(autoGift.qualifierId));
    }
    return body;
  }
  async function rollback(before, added, quantity) {
    let cart = await request('');
    const properties = {};
    for (const [name, value] of added.entries()) if (name.startsWith('properties[')) properties[name.slice(11, -1)] = value;
    const key = signature({ variant_id: added.get('id'), properties, selling_plan_allocation: added.get('selling_plan') ? { selling_plan: { id: added.get('selling_plan') } } : undefined });
    const previous = (before.items || []).filter(x => signature(x) === key).reduce((sum, x) => sum + x.quantity, 0);
    let remaining = Math.min(quantity, Math.max(0, (cart.items || []).filter(x => signature(x) === key).reduce((sum, x) => sum + x.quantity, 0) - previous));
    while (remaining > 0) {
      const line = cart.items.find(x => signature(x) === key);
      if (!line) break;
      const remove = Math.min(remaining, line.quantity);
      cart = await request('/change', { id: line.key, quantity: line.quantity - remove });
      remaining -= remove;
    }
    return reconcile(cart, true, false);
  }
  window.TPBundleCart = {
    register(value) { if (valid(value)) config = value; },
    reconcile(cart) { return lock(() => reconcile(cart)); },
    beginChange() {
      let resolve; const promise = new Promise(r => { resolve = r; }); nativeChanges.add(promise);
      return () => { nativeChanges.delete(promise); resolve(); };
    },
    showError,
    add(form, value) {
      return lock(async () => {
        config = value;
        const before = await request('');
        let attempted = false;
        let addedQuantity = Number(form.get('quantity'));
        try {
          // Count paid units separately so two purchases of two still earn the bonus.
          const previousQuantity = plan(before, config).quantity;
          const total = previousQuantity + addedQuantity;
          const paid = paidQuantity(previousQuantity) + paidQuantity(addedQuantity);
          const bonusQuantity = paid + Math.floor(paid / 3) - total;
          if (extraCodes(config).length !== 3 && bonusQuantity > 0) {
            addedQuantity += bonusQuantity;
          }
          const includeGift = autoGift.enabled && String(config.productId) === String(autoGift.qualifierId) &&
            !form.get('selling_plan') && !(before.items || []).some(matchesGift);
          if (includeGift && !giftAvailable()) throw new Error('El regalo digital no está disponible sin costo en este momento.');
          const projected = { ...before, items: [...(before.items || []), { product_id: config.productId, quantity: addedQuantity }] };
          const selected = plan(projected, config);
          attempted = true;
          await request('/add', addPayload(form, addedQuantity, includeGift));
          // update.js returns the full, authoritative cart and its rendered sections.
          let cart = await request('/update', {
            discount: selected.desired.join(','), attributes: { [attribute]: JSON.stringify(config) }, ...sectionRequest()
          });
          // Recheck actual quantities and the e-book in case another cart control changed them.
          cart = await reconcile(cart);
          const error = discountError(cart, config);
          if (error) throw new Error(error);
          publish(cart);
          return cart;
        } catch (error) {
          if (attempted) {
            try { publish(await rollback(before, form, addedQuantity), true); }
            catch { error.message += ' Revisa las cantidades del carrito antes de continuar.'; }
          }
          throw error;
        }
      });
    }
  };
  const initial = parse(document.querySelector('[data-tp-bundle-cart-config]')?.dataset.tpBundleCartConfig);
  if (valid(initial)) config = initial;
  document.addEventListener('cart:update', event => {
    // Other native add-to-cart forms may add this product outside its bundle page.
    if (event.detail?.data?.source !== 'product-form-component') return;
    const productId = event.detail.data.productId || event.detail.resource?.product_id;
    if (autoGift.enabled && String(productId) === String(autoGift.qualifierId)) giftCartRelevant = true;
    if (!config && !giftCartRelevant) return;
    lock(() => reconcile(null, true)).then(cart => publish(cart, true)).catch(error => showError(error.message));
  });
  document.addEventListener('quantity-selector:update', () => { lastQuantityChange = Date.now(); });
  // Before navigating to checkout, wait for quantity updates and validate Shopify's price.
  async function checkout(event, target) {
    if ((!config && !giftCartRelevant) || !target || target.disabled) return;
    event.preventDefault(); event.stopImmediatePropagation();
    const wasDisabled = target.disabled;
    target.disabled = true;
    try {
      const delay = 400 - (Date.now() - lastQuantityChange);
      if (delay > 0) await new Promise(resolve => setTimeout(resolve, delay));
      await Promise.all([...nativeChanges]);
      const cart = await lock(() => reconcile(null, true));
      publish(cart, true);
      const error = config ? discountError(cart, config) : '';
      if (error) throw new Error(error);
      location.assign(`${root()}checkout`);
    } catch (error) { showError(error.message || 'No se pudo validar el carrito. Intenta de nuevo.'); }
    finally { target.disabled = wasDisabled; }
  }
  document.addEventListener('click', event => {
    const target = event.target.closest?.('[name="checkout"], .cart__checkout-button, a[href$="/checkout"]');
    if (target) checkout(event, target);
  }, true);
  document.addEventListener('submit', event => {
    if (event.submitter?.name === 'checkout') checkout(event, event.submitter);
  }, true);
  if (autoGift.needsSync) lock(() => reconcile()).then(cart => publish(cart, true)).catch(error => showError(error.message));
})();
